"use client";

import { IconButton } from "@/src/components/buttons";
import { FaCheck, FaUndo } from "react-icons/fa";
import { IoMdUndo } from "react-icons/io";
import { LuUndo2 } from "react-icons/lu";

export type FieldAnswerAiEdit = {
  fieldId: string;
  oldValue: any;
  newValue: any;
};

export function AiEditWrapper({
  aiEdit,
  onUndo,
  onValidate,

  children,
}: {
  aiEdit: FieldAnswerAiEdit | null | undefined;
  onUndo: () => void;
  onValidate: () => void;
  children: any;
}) {
  if (!aiEdit || Object.keys(aiEdit).length == 0) return children;

  console.log("the aiEdit", aiEdit);

  return (
    <div className="greenish p10 c1 gap10 br">
      <div>{children}</div>
      <div className="grid right gap10" style={{ placeItems: "end" }}>
        <div className="c2 gap10">
          <IconButton
            onClick={() => {
              onUndo();
            }}
          >
            <LuUndo2 color="rgba(0,0,0,0.5)" size={18} />
          </IconButton>
          <IconButton
            onClick={() => {
              onValidate();
            }}
          >
            <FaCheck />
          </IconButton>
        </div>
      </div>
    </div>
  );
}
